import { render, staticRenderFns } from "./MediaUpload.vue?vue&type=template&id=3237b54c&scoped=true"
import script from "./MediaUpload.vue?vue&type=script&lang=ts"
export * from "./MediaUpload.vue?vue&type=script&lang=ts"
import style0 from "./MediaUpload.vue?vue&type=style&index=0&id=3237b54c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3237b54c",
  null
  
)

export default component.exports